// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2yN1R","choiceBoxes":"toolbarselects_choiceBoxes__2dR7y","simpleField":"toolbarselects_simpleField__3v5rw"};